<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [delete_permission]="gs.user_role_data?.masters_college_delete" [list]="items" [colDefs]="city_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex bg-white gap-4 items-center p-4 border-b border-gray-300">
    <div class="flex gap-4 flex-1">
        <app-select-input label="Country" class="flex-1" [(ngModel)]="filter_country_id" [options]="ds.dropdown_list?.country_list" (valueChange)="on_country_filter()"></app-select-input>
        <app-select-input label="State" class="flex-1" [(ngModel)]="filter_state_id" [options]="ds.dropdown_list?.state_list | filterByKeyAndValue : 'country.id' : filter_country_id" (valueChange)="on_state_filter()"></app-select-input>
        <app-select-input label="District" class="flex-1" [(ngModel)]="filter_district_id" [options]="ds.dropdown_list?.district_list | filterByKeyAndValue : 'state_id' : filter_state_id" (valueChange)="on_district_filter()"></app-select-input>
    </div>
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
    <app-dropdown-upload-button *ngIf="gs.user_role_data?.masters_college_add" [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"></app-dropdown-upload-button>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete_college()" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to Permanently delete the selected record ? This cannot be undone
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_college_ids.is_active == true ? false : true" [disabled_icon]="selected_college_ids.is_active == false ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_college_ids.is_active)" (close_modal_clicked)="confirmation_disabled_modal.close()">
    Are you sure you want to {{selected_college_ids.is_active == true? "Disable" :"Enable"}} College
</app-confirmation-popup>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
    <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>
<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Country Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{
                selected_college_ids?.City?.District?.State?.country?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">State Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.City?.District?.State?.name || '—'
                }}</p>
        </div>
        <!-- <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Division Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.City?.District?.Division?.name || '—' }}</p>
        </div> -->
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">District Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.City?.District?.name || '—' }}</p>
        </div>
        <!-- <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Taluka Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.City?.name || '—' }}</p>
        </div> -->
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">City Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.City?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">University</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.University?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Code</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.code || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Email</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.email || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Contact</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.contact || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Address</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_college_ids?.address || '—' }}</p>
        </div>
    </div>
</app-modal>